import React from 'react';
import styled from 'styled-components';

import { TenantSelector } from '../../header';

import { Panel, type PanelImperativeHandle } from '@controlrooms/components';

const SidePanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.v2.tab.containerBackgroundColor};
`;

const PortalContentArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  width: 100%;
`;

/**
 * SidePanel - Left panel (300px default when expanded, 0 when EmptyState), collapsible
 * Always displays TenantSelector at the top, followed by dynamic content via React Portal
 * View components can use: createPortal(content, document.getElementById('side-panel-portal-root'))
 * Accepts panelRef so parent can call collapse/expand (e.g. when switching to webhooks tab).
 */
export const SidePanel = React.memo<{
  panelRef?: React.RefObject<PanelImperativeHandle | null>;
  defaultSize?: string;
}>(({ panelRef, defaultSize = '300px' }) => {
  return (
    <Panel
      id="sidePanel"
      defaultSize={defaultSize}
      minSize={0}
      maxSize="90%"
      collapsedSize={0}
      collapsible
      style={{ overflow: 'hidden' }}
      panelRef={panelRef}
    >
      <SidePanelContainer>
        <TenantSelector height={50} />
        <PortalContentArea id="side-panel-portal-root" />
      </SidePanelContainer>
    </Panel>
  );
});

SidePanel.displayName = 'SidePanel';
